import React, { Component }     from "react";
import { EditorState, convertFromRaw, convertToRaw, ContentState } from 'draft-js';
import { Editor }               from 'react-draft-wysiwyg';
//import { draftToHtml }          from 'draftjs-to-html';
//import htmlToDraft              from 'html-to-draftjs';
import { API, Storage }         from "aws-amplify";
import { parseJsonForImages } from "../../screens/assessment/utils";
import { s3Upload, getS3Attachment } from "../../libs/awsLib";
//import "./AutoSuggest.css";
import '../../css/assessment/react-draft-wysiwyg.css';

const emptyTemplate = {"blocks":[{"key":"6t07u","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"dsmoh","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"7kb5d","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"3d1uk","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}
const questionnaireBasicTemplate = {"blocks":[{"key":"6t07u","text":"1. What’s your full name?","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":25,"style":"BOLD"},{"offset":0,"length":25,"style":"fontsize-18"}],"entityRanges":[],"data":{}},{"key":"2nvbq","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"63qjj","text":"2. What’s your email address?","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":29,"style":"BOLD"},{"offset":0,"length":29,"style":"fontsize-18"}],"entityRanges":[],"data":{}},{"key":"32sd1","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"cfiir","text":"3. What’s your phone number?","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":28,"style":"BOLD"},{"offset":0,"length":28,"style":"fontsize-18"}],"entityRanges":[],"data":{}},{"key":"9toh5","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"bi5a0","text":"4. What’s your biological sex?","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":30,"style":"BOLD"},{"offset":0,"length":30,"style":"fontsize-18"}],"entityRanges":[],"data":{}},{"key":"b7873","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"3akrl","text":"5. What’s your birth date? ","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":27,"style":"BOLD"},{"offset":0,"length":27,"style":"fontsize-18"}],"entityRanges":[],"data":{}},{"key":"dsmoh","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"3d1uk","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}

var page_load_flag = false;
export default class AssessmentEditor extends Component {
    constructor(props) {
        super(props);

        const contentState = convertFromRaw(emptyTemplate); //(questionnaireBasicTemplate)
        const editorState  = EditorState.createWithContent(contentState);

        this.state = {
            editorState, /// EditorState.createEmpty(),
            currentEditorImages: [],
            uploadedImages: [],
            initLoadImages: false
        };
    }

    // Returns if a value is an object
    isObject (value) {
        return value && typeof value === 'object' && value.constructor === Object;
    }

    componentWillReceiveProps(props) {

        var content = props.raw_content;
        var object_type = this.isObject(content);

        ////////////////////////////////////////////////////////////////////////
        // GET EXISTING IMAGES FOR EDITOR FROM JSON ONCE ONLY ON INITIAL LOAD //

        if(!this.state.initLoadImages) {
            this.validateContentForImages(content, object_type)
        }

    }

    componentWillUnmount() {
        // reset page load flag
        page_load_flag = false;
    }

    validateContentForImages = async (content, object_type) => {
            var that = this;

            // After executing parseJsonForImages(), a Promise Object is returned
            // We need to convert the Promist Object into a regular and useable Object via "then"

            if(object_type && !page_load_flag) {
                page_load_flag = true // only process existing editor images once

                var _process_content = await parseJsonForImages(content).
                    then(function(value) {
                        //console.log("value.entityMap: " + value.entityMap);
                        content.entityMap = value.entityMap;

                        // SET THE EXISTING IMAGES TO TRACK WHAT SHOULD BE DELETED IN AWS S3 //
                        that.props.setExistingEditorImages(value.img_src_arr)

                        if(content === undefined || content === null)
                            content = emptyTemplate;

                        // Upon initial load of component, load only the first set of data, not any subsequent data //
                        //if(object_type) {
                        console.log("2. content: " + content);
                        const contentState = convertFromRaw(content);
                        console.log("3. contentState: " + contentState);
                        const editorState  = EditorState.createWithContent(contentState);

                        that.setState({
                            editorState,
                            initLoadImages: true
                        })
                        console.log("FINISHED processing.");
                });
            }
    }

    onEditorStateChange = (editorState) => {

        var contentState = editorState.getCurrentContent();
        //console.log("---------------------------------------");

        var map = contentState.entityMap;

        var rawContent = JSON.stringify(convertToRaw(contentState))
        this.props.assessmentEditorContent(rawContent);

        this.setState({
            editorState: editorState
        });
    };

    uploadImageCallBack = async (file) => {
        //console.log("file: " + file);

        /* const imageObject = {
            file: file,
            localSrc: URL.createObjectURL(file),
        }

        let uploadedImages = this.state.uploadedImages;
        console.log("URL.createObjectURL(file): " + URL.createObjectURL(file));

        uploadedImages.push(imageObject);

        this.setState(uploadedImages: uploadedImages)

        // We need to return a promise with the image src
        // the img src we will use here will be what's needed
        // to preview it in the browser. This will be different than what
        // we will see in the index.md file we generate.
        return new Promise(
          (resolve, reject) => {
            resolve({ data: { link: imageObject.localSrc } });
          }
        );
        */

        ////  USES THE "BUCKET" FROM CONFIG.JS - BUCKET: "training-slate-admin-prod-documents"   ////
        const document_id = file ? await s3Upload(file) : null;
        //console.log("document_id: " + document_id);
        //var attachmentURL = await Storage.vault.get(document_id); //save attach url in db
        var attachmentURL = await getS3Attachment(document_id); //save attach url in db

        //console.log("attachmentURL: " + attachmentURL);

        if(attachmentURL != undefined) {
              return new Promise(
                  (resolve, reject) => {
                      // sample img url : "https://pbs.twimg.com/profile_images/2210573252/image_400x400.jpg"
                      resolve({ data: { link: attachmentURL} })
                  }
              )
        }/* */
             /*return new Promise(
                   (resolve, reject) => {

                     const xhr = new XMLHttpRequest();
                     xhr.open('POST', 'https://api.imgur.com/3/image');
                     xhr.setRequestHeader('Authorization', 'Client-ID XXXXX');
                     const data = new FormData();
                     data.append('image', file);
                     xhr.send(data);
                     xhr.addEventListener('load', () => {
                       const response = JSON.parse(xhr.responseText);
                       resolve(response);
                     });
                     xhr.addEventListener('error', () => {
                       const error = JSON.parse(xhr.responseText);
                       reject(error);
                     });
                   }
             );
         }*/
     }

     render() {
         const { editorState } = this.state;

         return (
            <div>
                <Editor
                    editorState         = {editorState}
                    // wrapperClassName    = "demo-wrapper"
                    // editorClassName     = "demo-editor"
                    onEditorStateChange = {this.onEditorStateChange}
                    toolbarHidden = { false }
                    toolbar = {{
                          inline: { inDropdown: true },
                          list: { inDropdown: true },
                          textAlign: { inDropdown: true },
                          link: { inDropdown: false },
                          history: { inDropdown: true },

                          image: {
                              uploadCallback: this.uploadImageCallBack,
                              urlEnabled: false,
                              previewImage: true,
                              defaultSize: {
                                 height: '400',
                                 width: 'auto',
                              },
                              alt: { present: false, mandatory: false}
                          },
                          options:['inline', 'blockType','fontSize','colorPicker','textAlign', 'list', 'history', 'emoji', 'image' ]
                    }}
                    />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/AssessmentEditor.js